import React from 'react';
import ImageLoader from 'react-imageloader';
import { CircularProgress } from 'material-ui/Progress';
import { ListItem, ListItemText } from 'material-ui/List';
import { GridList, GridListTile } from 'material-ui/GridList';

import Auth from '../../../psuite-js/helpers/auth';

const NO_IMAGE_URL = process.env.REACT_APP_NO_IMAGE_URL;
const IMAGE_BASE_URL = process.env.REACT_APP_ACTIVITIES_IMAGE_BASE_URL;

const PhotoItem = ({ data }) => {
    const session = Auth.getSessionData() || {};
    const company_id = session.company_id;
    const payload = data.payload;
    const task = payload.task || {};

    let value = payload.value || [];
    value = (typeof value === 'string') ? JSON.parse(value) : value;

    const preloader = () => <CircularProgress />;

    const openImage = photo => {
        const url = `${IMAGE_BASE_URL}/${company_id}/thumbs/${photo.id}.jpg`;
        window.open(url, '_blank');
    }

    const photos = value.map(photo => {
        const thumb_url = `${IMAGE_BASE_URL}/${company_id}/thumbs/${photo.id}.jpg`;

        return (
            <GridListTile
                key={photo.id}
                cols={1}
                onClick={openImage.bind(this, photo)}
                style={{cursor: 'pointer'}}>
                <ImageLoader
                    src={thumb_url}
                    imgProps={{height: '100px'}}
                    preloader={preloader}>
                        <div className="text-center">
                            <img src={NO_IMAGE_URL} alt="Foto não encontrada" />
                        </div>
                </ImageLoader>
            </GridListTile>

        )
    });

    return (
        <div>
            <ListItem>
                <i className="material-icons">photo_camera</i>
                <ListItemText primary={task.name} />
            </ListItem>

            <GridList cellHeight={100} cols={12} style={{padding: '16px'}}>
                {photos}
            </GridList>

            <ListItem>

            </ListItem>
        </div>
    );

}

export default PhotoItem;



// WEBPACK FOOTER //
// ./src/components/Timeline/Activities/Photo.js